import { useMemo, useRef, useState } from "react";
import { ColDef, ColumnState } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { aggridHeaderClass, pdaCellStyle } from "src/components/common/common";
import { GridContextWrapper } from "src/components/common/gridWrapper/GridContextWrapper";
import Grid_Select from "src/components/common/gridWrapper/Grid_Select";
import { PDA1122_R01OrderDto } from "./PDA1122_R01Dto";

interface Props {
  orderList: PDA1122_R01OrderDto[];
  onSelectOrder: (order: PDA1122_R01OrderDto) => void;
}

type Row = PDA1122_R01OrderDto & { inserted?: boolean };

const PDA1122_R01Table = ({ orderList, onSelectOrder }: Props) => {
  const gridRef = useRef<AgGridReact<Row>>(null);
  const gridWrapperRef = useRef<HTMLDivElement>(null);
  const [, setColumnState] = useState<ColumnState[] | null>(null);
  const [, setHoveredRowIndex] = useState<number | null>(null);
  const paddedGridData = useMemo(
    () => orderList.map((order) => ({ ...order, inserted: false })),
    [orderList]
  );

  const columnDefs: ColDef<Row>[] = useMemo(
    () => [
      {
        headerName: "일자",
        field: "orderDt",
        valueGetter: (params) => params.data?.orderDt || "-",
        cellStyle: { textAlign: "center", ...pdaCellStyle },
        headerClass: aggridHeaderClass,
        flex: 0.9,
        minWidth: 80,
      },
      {
        headerName: "공정명",
        field: "workplaceCd",
        valueGetter: (params) => params.data?.workplaceCd || "-",
        cellStyle: { textAlign: "center", ...pdaCellStyle },
        headerClass: aggridHeaderClass,
        flex: 0.9,
        minWidth: 80,
      },
      {
        headerName: "품명",
        field: "itemNm",
        valueGetter: (params) => params.data?.itemNm || "-",
        cellStyle: { textAlign: "left", ...pdaCellStyle },
        headerClass: aggridHeaderClass,
        flex: 1.5,
        minWidth: 80,
      },
      {
        headerName: "지시량",
        field: "orderQty",
        valueGetter: (params) =>
          params.data?.orderQty != null ? params.data.orderQty.toLocaleString() : "-",
        cellStyle: { textAlign: "right", justifyContent: "flex-end", ...pdaCellStyle },
        headerClass: aggridHeaderClass,
        flex: 0.8,
        minWidth: 80,
      },
    ],
    []
  );

  return (
    <div className="flex-1 p-3 pt-2 flex w-full h-full flex-col overflow-hidden">
      <GridContextWrapper
        gridRef={gridRef}
        gridWrapperRef={gridWrapperRef}
        paddedGridData={paddedGridData}
        initSelected={() => {}}
        baseColumnDefs={columnDefs}
        setColumnState={setColumnState}
        localStorageKey="PDA1122_R01_ColumnState"
        enableDataHistory={false}
      >
        <div className="flex-1 w-full h-full min-h-0">
          <Grid_Select<Row>
            ref={gridRef}
            rowData={paddedGridData}
            columnDefs={columnDefs}
            rowSelection="single"
            onRowClicked={(event) => event.data && onSelectOrder(event.data)}
            setHoveredRowIndex={setHoveredRowIndex}
            columnStateKey="PDA1122_R01_ColumnState"
            setColumnState={setColumnState}
          />
        </div>
      </GridContextWrapper>
    </div>
  );
};

export default PDA1122_R01Table;
